export default __webpack_public_path__ + "static/media/heartcoffe.fdd736cc.jpg";